import * as React from 'react';
import { FC } from 'react';
import classnames from 'classnames';
import { moneyAccurate as money } from 'app/helpers/money';
import { useContext } from './useFormContext';

const Result: FC<{ isAmountInLimits: boolean; resultSum: number; creditedCurrency: string }> = ({
  isAmountInLimits,
  resultSum,
  creditedCurrency,
}) => {
  const context = useContext();
  return (
    <div className="result">
      <div id="result-label">
        {`${
          context.isDeposit
            ? context.locales.will_be_credited_to_casino_label
            : context.locales.will_be_credited_to_paysystem_label
        }:`}
      </div>
      <div
        aria-labelledby="result-label"
        className={classnames({ error: !context.isDeposit && !isAmountInLimits, zero: resultSum === 0 }, 'value')}
      >
        {money(resultSum, creditedCurrency)}
      </div>
    </div>
  );
};

export default Result;
